import { Action, createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";
import { ReportsState } from "../../entities";
import * as ReportsAction from "../actions/reports.action";

const initialState: ReportsState = {
  reports: [],
  showZappieReports: false,
};

const reportsReduce = createReducer(
  initialState,
  on(ReportsAction.clearAll, () => initialState),
  on(ReportsAction.setReports, (state, { reports, showZappieReports }) => ({
    ...state,
    reports,
    showZappieReports,
  })),
  on(ReportsAction.deleteReport, (state, { id }) => ({
    ...state,
    reports: [...state.reports.filter(report => id !== report.id)],
  }))
);

export function ReportsReducer(state: ReportsState, action: Action) {
  return reportsReduce(state, action);
}

export const getReportsState = createFeatureSelector<ReportsState>("reports");
export const getReports = createSelector(getReportsState, ({ reports }) => reports);
export const getShowZappieReports = createSelector(getReportsState, ({ showZappieReports }) => showZappieReports);
